module.exports = __webpack_public_path__ + "static/img/wx_qr_code.28ffa1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/index/wx_qr_code.jpg
// module id = VXG1
// module chunks = 86